export default __webpack_public_path__ + "static/media/juseno_3.5a74353a.png";